import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { Toaster } from 'react-hot-toast'

// Auth Pages
import LoginPage from './pages/auth/LoginPage'
import SignupPage from './pages/auth/SignupPage'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import ResetPasswordPage from './pages/auth/ResetPasswordPage'

// Vendor Pages
import VendorDashboard from './pages/vendor/VendorDashboard'
import LegalEntityDetailsPage from './pages/vendor/LegalEntityDetailsPage'
import ProfileBuildingPage from './pages/vendor/ProfileBuildingPage'
import SubscriptionPlanPage from './pages/vendor/SubscriptionPlanPage'
import DocumentUploadPage from './pages/vendor/DocumentUploadPage'
import VendorBenchResources from './pages/vendor/VendorBenchResources'
import VendorProfileView from './pages/vendor/VendorProfileView'
import VendorOverview from './pages/vendor/pages/VendorOverview'
import VendorSubscription from './pages/vendor/pages/VendorSubscription'
import VendorPayments from './pages/vendor/pages/VendorPayments'
import VendorSettings from './pages/vendor/pages/VendorSettings'
import ChangePasswordPage from './pages/vendor/pages/ChangePasswordPage'
import VendorPurchaseOrders from './pages/vendor/pages/VendorPurchaseOrders'
import VendorInterviews from './pages/vendor/pages/VendorInterviews'
import VendorPlacements from './pages/vendor/pages/VendorPlacements'
import AddBenchResource from './pages/vendor/pages/AddBenchResource'

function App() {
  return (
      <AuthProvider>
          <div className="min-h-screen bg-gray-50 dark:bg-slate-900">
            <Routes>
              {/* Default Route - Login Page */}
              <Route path="/" element={<LoginPage />} />
             

              {/* Auth Routes */}
                <Route path="/auth/login" element={<LoginPage />} />
              <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/auth/reset-password" element={<ResetPasswordPage />} />

              {/* Registration Routes */}
              <Route path="/signup" element={<SignupPage />} />

              {/* Vendor Registration Routes */}
              <Route path="/vendor/registration/legal-details" element={<LegalEntityDetailsPage />} />
              <Route path="/vendor/registration/profile" element={<ProfileBuildingPage />} />
              <Route path="/vendor/registration/subscription" element={<SubscriptionPlanPage />} />
              <Route path="/vendor/registration/documents" element={<DocumentUploadPage />} />

              {/* Vendor Dashboard with Nested Routes */}
              <Route path="/vendor/dashboard" element={<VendorDashboard />}>
                <Route index element={<VendorOverview />} />
                <Route path="overview" element={<VendorOverview />} />
                <Route path="bench-resources" element={<VendorBenchResources />} />
                <Route path="add-bench-resource" element={<AddBenchResource />} />
                <Route path="purchase-orders" element={<VendorPurchaseOrders />} />
                <Route path="interviews" element={<VendorInterviews />} />
                <Route path="placements" element={<VendorPlacements />} />
                <Route path="subscription" element={<VendorSubscription />} />
                <Route path="payments" element={<VendorPayments />} />
                <Route path="settings" element={<VendorSettings />} />
                <Route path="settings/change-password" element={<ChangePasswordPage />} />
                <Route path="profile" element={<VendorProfileView />} />
              </Route>

            </Routes>

            <Toaster
              position="top-right"
              containerStyle={{
                zIndex: 9999,
              }}
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#1e293b',
                  color: '#fff',
                  borderRadius: '8px',
                  padding: '12px 16px',
                  zIndex: 9999,
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#22c55e',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
              gutter={8}
            />
          </div>
      </AuthProvider>
  )
}

export default App
